import { useGetIdentity, useNotification, useUpdate } from "@refinedev/core";
import { Button, Form, Space } from "antd";
import { ModalCloseButton } from "../../operation";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
} from "react";
import type { User } from "utils/types/user.type";
import { FormInput } from "../../form";
import { Modal, type ModalHandle } from "../../modal";
import { useNetworkState } from "react-use";

export const AdditionalFillInPopup = forwardRef<ModalHandle>((_, ref) => {
  const modalRef = useRef<ModalHandle>(null);
  const [form] = Form.useForm();
  const { mutateAsync: updateAsync, isLoading } = useUpdate();
  const { open } = useNotification();
  const { data: user, isSuccess, refetch } = useGetIdentity<User>();
  const { online } = useNetworkState();

  useImperativeHandle(ref, () => modalRef.current!);

  const isFilledIn = useMemo(() => {
    if (isSuccess && user) {
      return user.company_name && user.nickname;
    }
    return true;
  }, [user, isSuccess]);
  useEffect(() => {
    if (!isFilledIn) {
      modalRef.current?.open();
    }
  }, [isFilledIn]);
  const onCancel = () => {
    if (isFilledIn) {
      modalRef.current?.close();
    }
  };

  // const footer = (
  //   <Button type="primary" loading={isLoading} onClick={() => form.submit()}>
  //     提出
  //   </Button>
  // );

  const footer = useMemo(
    () =>
      isFilledIn ? (
        <Space>
          <ModalCloseButton modalRef={modalRef} />
          <Button
            type="primary"
            loading={isLoading}
            onClick={() => form.submit()}
          >
            確認
          </Button>
        </Space>
      ) : (
        <Button
          type="primary"
          loading={isLoading}
          onClick={() => form.submit()}
        >
          提出
        </Button>
      ),
    [isLoading, isFilledIn]
  );
  const title = useMemo(
    () => (isFilledIn ? "個人情報を変更する" : "情報を完備する"),
    [isFilledIn]
  );

  const onFinish = async (values: User) => {
    if (!online) return;
    if (!user) return;
    await updateAsync({
      resource: "users",
      id: user?.id,
      values,
    });
    refetch();
    open?.({
      type: "success",
      message: "提出に成功しました。",
      key: "notification-update",
    });
    modalRef.current?.close();
  };

  return (
    <Modal
      ref={modalRef}
      title={title}
      footer={footer}
      onCancel={onCancel}
      closeIcon={isFilledIn ? undefined : false}
      destroyOnClose
    >
      <Form
        form={form}
        labelCol={{ span: 4 }}
        onFinish={onFinish}
        initialValues={user}
      >
        <FormInput name="nickname" label="名前" rules={[{ required: true }]} />
        <FormInput
          name="company_name"
          label="会社名"
          rules={[{ required: true }]}
        />
      </Form>
    </Modal>
  );
});
